/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-06 09:36:00
 * @LastEditTime: 2020-09-27 09:39:14
 * @Description: 
 */
import {
    getSacCompanys,
    createSacCompany,
    updateSacCompany
} from '@/api/sacCompany'
import Vue from 'vue'

const state = {
    sacCompanys: [],
    totalCounts: 0
}

const getters = {
    getSacCompanyById: (state) => (id) => {
        return state.sacCompany.find(x => x._id === id)
    }
}

const actions = {
    async getSacCompanysAction({
        commit
    }, payload) {
        try {
            const sacCompany = await getSacCompanys(payload.api)
            commit('SETSACCOMPAYNS', sacCompany.data)
            return sacCompany.data
        } catch (error) {
            throw error.message
        }
    },
    async createSacCompanyAction({
        commit
    }, payload) {
        try {
            const newSacCompany = await createSacCompany(payload);
            commit('ADDNEWSACCOMPANY', newSacCompany.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateSacCompanyAction({
        commit
    }, payload) {
        try {
            const newSacCompany = await updateSacCompany(payload.id, payload.data)
            commit('UPDATESACCOMPANY', newSacCompany.data)
            return newSacCompany.data
        } catch (error) {
            throw error.message
        }
    },
    async deleteSacCompanyAction({
        commit
    }, payload) {
        try {
            await deleteSacCompany(payload.id)
        } catch (error) {
            throw error.message
        }
    }
}

const mutations = {
    SETSACCOMPAYNS(state, payload) {
        state.sacCompanys = payload.sacCompanyList
        state.totalCounts = payload.totalCounts
    },
    ADDNEWSACCOMPANY(state, sacCompany) {
        state.sacCompanys.unshift(sacCompany)
        state.totalCounts++
    },
    UPDATESACCOMPANY(state, sacCompany) {
        Vue.set(state.sacCompanys, state.sacCompanys.findIndex(x => x._id === sacCompany._id), sacCompany)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}